module.exports = __webpack_public_path__ + "static/kdb-banner-4@2x-80ef18a0c3b41dc4dde78a88a21a4f4a.png";